(function () {
  'use strict';

  var DESKTOP_PER_PAGE = 4;
  var MOBILE_BREAKPOINT = 640;

  document.querySelectorAll('.zen-tabbed-collections').forEach(initSection);

  function getPerPage() {
    return window.innerWidth < MOBILE_BREAKPOINT ? 1 : DESKTOP_PER_PAGE;
  }

  function initSection(section) {
    var tabs = section.querySelectorAll('[data-zen-tc-tab]');
    var panels = section.querySelectorAll('[data-zen-tc-panel]');
    var viewAllLink = section.querySelector('[data-zen-tc-view-all]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-zen-tc-tab');

        tabs.forEach(function (t) {
          t.classList.remove('zen-tc__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('zen-tc__tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          var isTarget = p.getAttribute('data-zen-tc-panel') === idx;
          p.classList.toggle('zen-tc__panel--active', isTarget);
          p.hidden = !isTarget;
        });

        if (viewAllLink) {
          var url = tab.getAttribute('data-collection-url');
          if (url) viewAllLink.href = url;
        }

        var activePanel = section.querySelector('.zen-tc__panel--active');
        if (activePanel) {
          var track = activePanel.querySelector('.zen-tc__track');
          if (track) track.scrollLeft = 0;
          updatePagination(activePanel, 0);
        }
      });
    });

    // Build dots + setup pagination per panel
    panels.forEach(function (panel) {
      buildDots(panel);
      setupPagination(panel);
    });

    // Rebuild dots on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        panels.forEach(function (panel) {
          buildDots(panel);
        });
      }, 200);
    });

    // Setup image arrows
    setupImageArrows(section);
  }

  function buildDots(panel) {
    var pagination = panel.querySelector('[data-zen-tc-pagination]');
    if (!pagination) return;

    var totalSlides = parseInt(pagination.getAttribute('data-total-slides'), 10) || 0;
    var perPage = getPerPage();
    var totalPages = totalSlides <= perPage ? 1 : 1 + (totalSlides - perPage);
    if (totalPages < 1) totalPages = 1;

    var dotsContainer = pagination.querySelector('[data-zen-tc-dots]');
    var totalDisplay = pagination.querySelector('[data-zen-tc-total-pages]');

    // Update total counter
    if (totalDisplay) {
      totalDisplay.textContent = String(totalPages).padStart(2, '0');
    }

    // Build dot buttons
    var html = '';
    for (var i = 0; i < totalPages; i++) {
      html += '<button class="zen-tc__dot' + (i === 0 ? ' zen-tc__dot--active' : '') + '" data-zen-tc-dot="' + i + '" aria-label="Go to page ' + (i + 1) + '"></button>';
    }
    dotsContainer.innerHTML = html;

    // Re-bind dot clicks
    var track = panel.querySelector('.zen-tc__track');
    dotsContainer.querySelectorAll('[data-zen-tc-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var pageIdx = parseInt(dot.getAttribute('data-zen-tc-dot'), 10);
        scrollToPage(track, pageIdx);
        updatePagination(panel, pageIdx);
      });
    });

    // Reset to page 0
    updatePagination(panel, 0);
  }

  function setupPagination(panel) {
    var track = panel.querySelector('.zen-tc__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.zen-tc__slide'));
    if (!slides.length) return;

    function pageFromFirstVisible(firstIdx) {
      var perPage = getPerPage();
      var maxPage = Math.max(0, slides.length - perPage);
      return Math.min(Math.max(0, firstIdx), maxPage);
    }

    function syncNow() {
      var page = getCurrentPage(track);
      updatePagination(panel, page);
    }

    // Primary: IntersectionObserver on slides relative to the track viewport
    if ('IntersectionObserver' in window) {
      var ratios = new Array(slides.length).fill(0);
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var idx = slides.indexOf(entry.target);
          if (idx !== -1) ratios[idx] = entry.intersectionRatio;
        });
        var firstIdx = 0;
        for (var i = 0; i < ratios.length; i++) {
          if (ratios[i] >= 0.6) { firstIdx = i; break; }
        }
        updatePagination(panel, pageFromFirstVisible(firstIdx));
      }, { root: track, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });
      slides.forEach(function (slide) { observer.observe(slide); });
    }

    // Fallback + reinforcement: scroll/touch listeners
    var ticking = false;
    var endTimer;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { syncNow(); ticking = false; });
        ticking = true;
      }
      clearTimeout(endTimer);
      endTimer = setTimeout(syncNow, 120);
    }, { passive: true });

    track.addEventListener('scrollend', syncNow);
    track.addEventListener('touchend', function () {
      clearTimeout(endTimer);
      endTimer = setTimeout(syncNow, 120);
    }, { passive: true });
  }

  function scrollToPage(track, pageIdx) {
    var slides = track.querySelectorAll('.zen-tc__slide');
    if (!slides.length) return;

    var targetIdx = Math.min(Math.max(0, pageIdx), slides.length - 1);
    var targetSlide = slides[targetIdx];
    if (!targetSlide) return;

    var slideLeft = targetSlide.getBoundingClientRect().left;
    var trackLeft = track.getBoundingClientRect().left;
    track.scrollTo({
      left: track.scrollLeft + (slideLeft - trackLeft),
      behavior: 'smooth'
    });
  }

  function getCurrentPage(track) {
    var slides = track.querySelectorAll('.zen-tc__slide');
    if (!slides.length) return 0;

    var perPage = getPerPage();
    var trackLeft = track.getBoundingClientRect().left;

    var closestIdx = 0;
    var closestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var dist = Math.abs(slides[i].getBoundingClientRect().left - trackLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closestIdx = i;
      }
    }

    var maxPage = Math.max(0, slides.length - perPage);
    if (closestIdx > maxPage) closestIdx = maxPage;
    if (closestIdx < 0) closestIdx = 0;
    return closestIdx;
  }

  function updatePagination(panel, pageIdx) {
    var dots = panel.querySelectorAll('[data-zen-tc-dot]');
    var currentEl = panel.querySelector('[data-zen-tc-current-page]');

    dots.forEach(function (dot) {
      var dotIdx = parseInt(dot.getAttribute('data-zen-tc-dot'), 10);
      dot.classList.toggle('zen-tc__dot--active', dotIdx === pageIdx);
    });

    if (currentEl) {
      currentEl.textContent = String(pageIdx + 1).padStart(2, '0');
    }
  }

  // Image arrows per card
  function setupImageArrows(section) {
    var cards = section.querySelectorAll('[data-zen-card-slider]');
    cards.forEach(function (card) {
      var slides = card.querySelectorAll('[data-zen-card-slide]');
      if (slides.length <= 1) return;

      var prevBtn = card.querySelector('[data-zen-card-prev]');
      var nextBtn = card.querySelector('[data-zen-card-next]');
      var current = 0;
      var total = slides.length;

      function showSlide(idx) {
        slides.forEach(function (s) {
          s.classList.remove('zen-tc-card__image-slide--active');
        });
        slides[idx].classList.add('zen-tc-card__image-slide--active');
        current = idx;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          showSlide(current <= 0 ? total - 1 : current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          showSlide(current >= total - 1 ? 0 : current + 1);
        });
      }
    });
  }
})();
